import { defineSlotRecipe } from '@chakra-ui/react';

export const savedJobCardSlotRecipe = defineSlotRecipe({
	className: 'InterestedJobCard',

	base: {
		root: { padding: 0 },

		body: {
			alignItems:    'end',
			display:       'flex',
			flexDirection: 'row',
			gap:           'md',
			padding:       'md',
		},
		footer: {
			'alignItems':     'center',
			'borderTop':      '1px solid {colors.gray.15}',
			'display':        'flex',
			'justifyContent': 'space-between',
			'paddingX':       'md',
			'paddingY':       'xs',

			'& > p': {
				color:     'gray.100',
				textStyle: 'body',
			},
		},
		textBody: {
			'& > svg':   { color: 'primary.120' },
			'textStyle': 'body',
		},
		textTitle: {
			color:     'primary.100',
			textStyle: 'h3',
		},
	},
	slots: [
		'root', 'body', 'footer', 'textTitle', 'textBody',
	],
	variants: {
		status: {
			closed: {
				textTitle: { color: 'gray.50' },

				textBody: {
					'& > svg': { color: 'gray.50' },
					'color':   'gray.50',
				},
			},
		},
	},
});
